










export default {
  props: {
    feedbackRating: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      feedbackRatingMap: {
        easy: 'Easy',
        ok: 'OK',
        hard: 'Hard',
      },
    }
  },
  computed: {
    buttons() {
      return Object.values(this.feedbackRatingMap).map(value => ({
        classes: { active: this.feedbackRating === value },
        label: value,
        events: {
          click: () => {
            this.$emit('update:feedback-rating', value)
          },
        },
      }))
    },
  },
}
